import script from "./TourDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./TourDesktop.vue?vue&type=script&setup=true&lang=ts"

import "./TourDesktop.vue?vue&type=style&index=0&id=138259ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-138259ba"]])

export default __exports__